import { Injectable } from '@angular/core'
import _ from 'lodash'

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {

    private pendingNavigationSource: string | null = null

    public initialize(): void {
        // @ts-ignore
        if (CA_CONFIG.GOOGLEANALYTICSKEY && window.gtag) {
            // @ts-ignore
            window.gtag('config', CA_CONFIG.GOOGLEANALYTICSKEY, {
                // @ts-ignore
                app_version: CA_CONFIG.VERSION,
                send_page_view: false,
            })
        }
    }

    setProject(project): boolean {
        // @ts-ignore
        if (!window.gtag) {
            return false
        }
        if (project) {
            // @ts-ignore
            window.gtag('set', 'user_properties', {
                project_key: project.key
            })

        } else {
            // @ts-ignore
            window.gtag('set', 'user_properties', {
                project_key: '(not set)'
            })
        }
    }

    logEvent(category, action, label?, numberValue?): boolean {
        // @ts-ignore
        if (!window.gtag) {
            return false
        }
        // @ts-ignore
        window.gtag('event', action, {
          'event_category': category,
          'event_label': label,
          'value': numberValue
        })
    }

    setNavigationSource(source: string): void {
        this.pendingNavigationSource = source
    }

    logPageview(pageRoute, pageTitle): boolean {
        // @ts-ignore
        if (!window.gtag) {
            return false
        }
        pageRoute = pageRoute.replace(/^main\./, '')
        pageRoute = pageRoute.replace(/\./g, ' ')

        if (!pageTitle && pageRoute === 'login') {
            pageTitle = 'Přihlášení'
        }
        if (pageRoute === 'subjects show') {
            pageTitle = 'Detail osoby [redacted]'
        }

        const navigationSource = this.pendingNavigationSource || 'direct_url'
        this.pendingNavigationSource = null

        // @ts-ignore
        window.gtag('event', 'page_view', {
            'page_location': pageRoute,
            'page_title': pageTitle,
            'navigation_source': navigationSource,
        })
    }

    userLoggedIn = (username, projectKey, webRegistration, adminPermission?): boolean => {
        // @ts-ignore
        if (!window.gtag) {
            return false
        }
        // window.gtag('consent', 'default', {'analytics_storage':   'granted'}) // nyní není vyžadováno
        // @ts-ignore
        window.gtag('set', 'user_properties', {
            user_id: this.hashString(username),
            project_key: projectKey,
            cf_employee: this.isCfEmployee(username, adminPermission),
            web_registration: webRegistration,
        })
    }

    userLoggedOut(): boolean {
        // @ts-ignore
        if (!window.gtag) {
            return false
        }
        // @ts-ignore
        window.gtag('set', 'user_properties', {
            project_key: '(not set)',
            cf_employee: '(not set)',
            web_registration: '(not set)',
        })
    }

    /************************************************************************/

    private hashString(str): number {
        var hash = 0
        if (str.length === 0) {
            return hash
        }
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i)
            hash = ((hash << 5) - hash) + char
            hash |= 0 // Convert to 32bit integer
        }
        return hash
    }

    private isCfEmployee(username, adminPermission): boolean {
        return (
            adminPermission
            || _.includes(username, '@cleverfarm.')
            || _.includes(username, '@cleverassets.')
            || _.includes(username, '@clevermaps.')
        )
    }
}
